import 'core-js/stable';
import 'regenerator-runtime/runtime';
// i18next needs Intl.PluralRules (Safari < 13 lacks it); only installed when missing
import 'intl-pluralrules';

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles.less'
import App from './App';
import reportWebVitals from './reportWebVitals';

import './i18n';

createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register({
//     onUpdate: (registration) => {
//         console.log('registration updated?');
//         const waitingServiceWorker = registration.waiting;
//
//         if (waitingServiceWorker) {
//             console.log('Service Worker is waiting for Update!');
//             waitingServiceWorker.addEventListener('statechange', (event) => {
//                 if (event && event.target && 'state' in event.target) {
//                     if (event.target?.state === 'activated') {
//                         window.location.reload();
//                     }
//                 }
//             });
//             waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
//         }
//     },
// });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
